/**
 * BulkDeleteConfirmModal Component
 * 
 * Toplu silme onay modalı.
 */

import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

export const BulkDeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedCount
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  // Govde: sari {count} vurgu span'i korunur (|| sentinel ile bol, ortadaki parca highlight)
  const bulkBodyParts = t('modals.bulk_delete_body', { count: selectedCount }).split('||');

  return (
    <div 
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
      data-testid="bulk-delete-modal"
    >
      <Card className="bg-gray-900 border-2 border-red-500 max-w-md w-full">
        <CardContent className="p-6">
          <h3 className="text-xl font-bold text-white mb-4">
            {t('modals.bulk_delete_title')}
          </h3>
          
          <p className="text-gray-300 mb-6">
            {bulkBodyParts[0]}
            <strong className="text-[#FFDD59]">{bulkBodyParts[1]}</strong>
            {bulkBodyParts[2]}
          </p>
          
          <div className="flex gap-4">
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1 border-gray-600 text-gray-300 hover:bg-gray-800"
              data-testid="bulk-delete-cancel-btn"
            >
              {t('common.cancel')}
            </Button>
            <Button
              onClick={onConfirm}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white"
              data-testid="bulk-delete-confirm-btn"
            >
              {t('modals.bulk_delete_confirm')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BulkDeleteConfirmModal;
